import { isFSA } from 'flux-standard-action';
import { types } from '../../actions/analytics';

import config from '../../config';

const isProduction = process.env.NODE_ENV === 'production';

const defaultSelect = (action) => {
  if (action.type === types.ANALYTICS_EVENT || action.type === types.ANALYTICS_PAGEVIEW) {
    return action;
  } else if (action.meta) {
    return action.meta.analytics;
  }
};

const analytics = (track, select = defaultSelect) => store => next => (action) => {
  const returnValue = next(action);

  if (!action) {
    return returnValue;
  }

  const event = select(action);

  if (!event) {
    return returnValue;
  }

  if (!isFSA(event)) {
    const message = "The following event wasn't tracked because it isn't a Flux Standard Action (https://github.com/acdlite/flux-standard-action)";
    console.error(message, event);
    return returnValue;
  }

  track(event, store.getState());

  return returnValue;
};

const trackGa = (type, payload) => {
  switch (type) {
    case types.ANALYTICS_PAGEVIEW:
      console.log(type, payload);
      return window.gtag('config', `${config.googleTagManagerId}`, payload);
    case types.ANALYTICS_EVENT:
    default:
      const { hitType, ...rest } = payload;
      return window.gtag('event', hitType, rest);
  }
};

const track = (type, payload) => {
  const hasGa = window.gtag;

  if (isProduction && hasGa) {
    trackGa(type, payload);
  } else {
    console.log(type, payload);
  }
};


const analyticsMiddleware =
  analytics(({ type, payload }) => track(type, payload));

export default analyticsMiddleware;



// WEBPACK FOOTER //
// ./src/store/middleware/analytics.js